import React, { useState } from "react";
import "./project.css";

const Projects = () => {
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [activeTab, setActiveTab] = useState(0); // State to track active tab

  const toggleFilter = () => {
    setIsFilterOpen((prev) => !prev);
  };

  const handleTabClick = (tabIndex) => {
    setActiveTab(tabIndex);
  };

  return (
    <div>
      <div className="flex flex-col">
        {/* Header Section */}
        <div className="w-full h-20 border-b border-gray-100 flex justify-between items-center px-4">
          <div className="flex flex-row gap-2 items-center">
          <button
              className="flex flex-row gap-2 items-center px-4 py-2 border text-lg text-gray-600 font-roboto  border-gray-300 rounded"
              onClick={toggleFilter}
            >
              <img
                className="w-6 h-6"
                alt=""
                src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIiB4PSIwIiB5PSIwIiB2aWV3Qm94PSIwIDAgMjQgMjQiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDUxMiA1MTIiIHhtbDpzcGFjZT0icHJlc2VydmUiPjxnPjxwYXRoIGQ9Ik0xOCAxM0g2Yy0uNiAwLTEtLjQtMS0xcy40LTEgMS0xaDEyYy42IDAgMSAuNCAxIDFzLS40IDEtMSAxek0xNSAxOUg5Yy0uNiAwLTEtLjQtMS0xcy40LTEgMS0xaDZjLjYgMCAxIC40IDEgMXMtLjQgMS0xIDF6TTIxIDdIM2MtLjYgMC0xLS40LTEtMXMuNC0xIDEtMWgxOGMuNiAwIDEgLjQgMSAxcy0uNCAxLTEgMXoiIGZpbGw9IiMwMDAwMDAiIG9wYWNpdHk9IjEiIGRhdGEtb3JpZ2luYWw9IiMwMDAwMDAiPjwvcGF0aD48L2c+PC9zdmc+"
              />{" "}
              Filter
            </button>

            <h1 className="text-3xl font-semibold text-gray-500 font-roboto">
              Projects
            </h1>
          </div>
          <div className="bg-blue-500 rounded">
            <button
              className={`px-6 py-3 border-l border-blue-200 text-md text-white font-roboto font-semibold ${
                activeTab === 0 ? "active bg-blue-900 rounded-l" : ""
              }`}
              onClick={() => handleTabClick(0)}
            >
              New
            </button>
            <button
              className={`px-6 py-3 border-l border-blue-200 text-md text-white font-roboto font-semibold ${
                activeTab === 1 ? "active bg-blue-900" : ""
              }`}
              onClick={() => handleTabClick(1)}
            >
              Quote Sent
            </button>
            <button
              className={`px-6 py-3 border-l border-blue-200 text-md text-white font-roboto font-semibold ${
                activeTab === 2 ? "active bg-blue-900" : ""
              }`}
              onClick={() => handleTabClick(2)}
            >
              Action Needed
            </button>
            <button
              className={`px-6 py-3 border-l border-blue-200 text-md text-white font-roboto font-semibold ${
                activeTab === 3 ? "active bg-blue-900" : ""
              }`}
              onClick={() => handleTabClick(3)}
            >
              Signed
            </button>
            <button
              className={`px-6 py-3 border-l border-blue-200 text-md text-white font-roboto font-semibold ${
                activeTab === 4 ? "active bg-blue-900 rounded-r" : ""
              }`}
              onClick={() => handleTabClick(4)}
            >
              Lost
            </button>
          </div>
          <div className="w-32"></div>
        </div>

        <div className="flex flex-row w-full h-screen">
          {/* Sidebar */}
          <div
            className={`bg-blue-100 h-screen transition-all duration-300 ${
              isFilterOpen ? "w-[20%]" : "w-0"
            }`}
          ></div>

          {/* Main Content */}
          <div
            className={`bg-blue-50 h-screen transition-all duration-300 ${
              isFilterOpen ? "w-[80%]" : "w-full"
            }`}
          >
            {/* Tab Content */}
            <div className="tab-content">
              {activeTab === 0 && (
                <div className="p-4">Content for New Tab</div>
              )}
              {activeTab === 1 && (
                <div className="p-4">Content for Quote Sent Tab</div>
              )}
              {activeTab === 2 && (
                <div className="p-4">Content for Action Needed Tab</div>
              )}
              {activeTab === 3 && (
                <div className="p-4">Content for Signed Tab</div>
              )}
              {activeTab === 4 && (
                <div className="p-4">Content for Lost Tab</div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Projects;
